import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from '../../../../services/common/common.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { PgsOrderService } from '../../../../services/seed/pgs-order.service';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';

@Component({
  selector: 'app-proving-ground-seed-order-landing',
  templateUrl: './proving-ground-seed-order-landing.component.html',
  styleUrl: './proving-ground-seed-order-landing.component.scss'
})
export class ProvingGroundSeedOrderLandingComponent implements OnInit, OnDestroy {
  @ViewChild('pgsPaginator', { read: MatPaginator }) pgsPaginator: MatPaginator;
  @ViewChild('pgsSort', { read: MatSort }) pgsSort: MatSort;
  masterConstants = MasterConstants;
  subscription = new Subscription();
  dataSource = new MatTableDataSource<any>([]);
  filter: PgsLandingFilterVM = new PgsLandingFilterVM();
  displayedColumns: string[] = [
    'webOrderNumber',
    'salesManagerAccountNumber',
    'salesManagerAccountName',
    'accountNumber',
    'accountName',
    'parentAccountNumber',
    'parentAccountName',
    'productLine',
    'packName',
    'orderDate',
    'orderedQuantity',
    'status'
  ];

  filterOptionsData: Array<FilterOption> = [
    { label: 'Sales Manager Account', key: 'salesManagerAccountNumber', controlType: ControlType.Text },
    { label: 'Sales Manager Name', key: 'salesManagerName', controlType: ControlType.Text },
    { label: 'Account Number', key: 'accountNumber', controlType: ControlType.Text },
    { label: 'Account Name', key: 'accountName', controlType: ControlType.Text },
    { label: 'Parent Account Number', key: 'parentAccountNumber', controlType: ControlType.Text },
    { label: 'Parent Account Name', key: 'parentAccountName', controlType: ControlType.Text },
    { label: 'Web Order Number', key: 'webOrderNumber', controlType: ControlType.Text },
    { label: 'Product Line', key: 'productLine', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: true },
    { label: 'Pack Name', key: 'packName', controlType: ControlType.Text },
    { label: 'Item Number', key: 'itemNumber', controlType: ControlType.Text },
    { label: 'Hybrid Variety', key: 'hybridVariety', controlType: ControlType.Text },
    { label: 'Status', key: 'status', controlType: ControlType.DropDown, controlData: [], controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: true }
  ];

  hasOldFilter = false;
  showCreateButton = false;
  showPackModal = false;
  selectedPackName = '';
  selectedPackDetails: any[] = [];
  packDisplayedColumns: string[] = ['itemNumber', 'hybridVariety', 'quantity', 'uom'];

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private pgsOrderService: PgsOrderService,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data && data.resultData && data.resultData.length > 0) {
        const userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE)?.userMenuAccessList;

        if (!this.commonService.checkUserRoleAccessTypeForMenu(userMenuAccessList, MasterConstants.FUNCTION_CODE.PROVING_GROUND_SEED_ORDER)) {
          this.router.navigate(['/cc/landing-data']);
          return;
        }
        const oldFilters = this.pgsOrderService.getOldFilters();
        if (oldFilters) {
          this.hasOldFilter = true;
          Object.keys(oldFilters).forEach(key => {
            const value = oldFilters[key];
            if (value !== null && value !== undefined && value !== '') {
              this.filter[key] = value;
            }
          });
          this.pgsOrderService.setOldFilters(null);
        }
        this.setDropDownValues();
        this.loadGridData(true);
        this.showCreateButton = this.commonService.checkUserRoleAccessType(
          MasterConstants.FUNCTION_CODE.PROVING_GROUND_SEED_ORDER,
          MasterConstants.USER_ACCESS.EDIT_FULL,
          userMenuAccessList
        );
      }
    }
  }



  setDropDownValues() {
    this.loaderService.setLoaderStatus(true);
    const forkJoinApIs = [];
    forkJoinApIs.push(this.pgsOrderService.getProductLines());
    forkJoinApIs.push(this.pgsOrderService.getStatusList());
    this.subscription.add(forkJoin(forkJoinApIs).subscribe((result: any[]) => {
      if (result && result.length > 0) {
        this.loadProductLines(result[0]);
        this.setStatusDropDownValues(result[1]);
      }
      this.loaderService.setLoaderStatus(false);
    }));

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setPgsTableHeight();
  }


  // set account table height
  setPgsTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 300;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

loadProductLines(result) {
      const rows = result || [];
      this.filterOptionsData.find(x => x.key === 'productLine').controlData =
        [{ id: '', value: 'Select All' }, ...rows.map(x => ({ id: x.id, value: x.value }))];
      this.applyOldFilterValues();
  }

  // Show the restored filter values in the filter control
  applyOldFilterValues() {
    if (!this.hasOldFilter) {
      return;
    }
    this.filterOptionsData.forEach(option => {
      const value = this.filter[option.key];
      if (value === null || value === undefined || value === '') {
        return;
      }
      option.filterValue = option.controlType === ControlType.DropDown
        ? String(value).split(',').map(s => s.trim())
        : value;
    });
    this.filterOptionsData = [...this.filterOptionsData];
  }

  filterSearchClick(event) {
    this.filter = event;
    this.loadGridData(false);
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.loadGridData(false);
  }

  // Set Status drop down values from the loaded data
  setStatusDropDownValues(statuses) {
    this.filterOptionsData.find(x => x.key === 'status').controlData = statuses && statuses.length > 0 ? statuses : [];
    this.applyOldFilterValues();
  }

  loadGridData(isFirstTimeLoad: boolean = false) {
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.pgsOrderService.getLandingData(this.filter).subscribe((result: any[]) => {
      this.dataSource = new MatTableDataSource(result || []);
      this.dataSource.paginator = this.pgsPaginator;
      this.dataSource.sort = this.pgsSort;
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
      this.loaderService.setLoaderStatus(false);
    }, _ => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Proving Ground Seed orders could not be retrieved. Please try again.');
      this.dataSource = new MatTableDataSource([]);
    }));
  }

  export() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.pgsOrderService.exportToExcel(this.filter).subscribe((result: any) => {
      this.loaderService.setLoaderStatus(false);
      if (result) {
        this.pgsOrderService.base64toFile(result.base64, result.mimeType, result.fileName);
      }
    }, _ => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('An error occurred during export.');
    }));
  }

  createNewOrder() {
    this.pgsOrderService.setOldFilters(this.filter);
    this.router.navigate(['/proving-ground-seed/proving-ground-seed-create-order']);
  }

  navigateOrderDetail(row: any) {
    if (!row) {
      return;
    }

    this.pgsOrderService.setOldFilters(this.filter);
    this.pgsOrderService.setPgsOrderHeaderId(+row.pgsOrderHeaderId);
    this.router.navigate(['/proving-ground-seed/proving-ground-seed-create-order']);
  }

  openPackDetails(row: any) {
    if (!row || !row.pgsPackConfigHeaderId) {
      return;
    }

    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.pgsOrderService.getPackDetails(row.pgsPackConfigHeaderId).subscribe((result: any[]) => {
      this.loaderService.setLoaderStatus(false);
      this.selectedPackDetails = result || [];
      this.selectedPackName = this.selectedPackDetails.length > 0 ? this.selectedPackDetails[0].packName : row.packName;
      this.showPackModal = true;
    }, _ => {
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Pack details could not be retrieved. Please try again.');
    }));
  }

  closePackModal() {
    this.showPackModal = false;
    this.selectedPackDetails = [];
    this.selectedPackName = '';
  }
}
export class PgsLandingFilterVM {
  webOrderNumber: string;
  salesManagerAccountNumber: string;
  salesManagerName: string;
  accountNumber: string;
  accountName: string;
  parentAccountNumber: string;
  parentAccountName: string;
  productLine: string;
  packName: string;
  itemNumber: string;
  hybridVariety: string;
  status: string;
}
